export default "__VITE_PUBLIC_ASSET__88bb1c1f__"